import React, { Component } from 'react';
import SearchLayout from './SearchLayout';
import '../css/style.css';
import '../components/Home.css';
import { translate } from "react-i18next";
import {GREEN_BG, GREEN_BORDER} from '../backend/Colors';



class SearchActivityLayout extends Component {

   //eventKey="1"
 render() {
    const { t } = this.props;
   
    return <SearchLayout   title={t("activities")} searchType="ACTIVTY" bg={GREEN_BG} bgStrong={GREEN_BORDER} />
 }
}


export default translate("translations")(SearchActivityLayout);